import { Component } from "@angular/core";
import { PopoverController } from "@ionic/angular";

import { environment } from '@env';

@Component({
    template: `
        <ion-list>
            <!-- <ion-list-header>Ionic</ion-list-header> -->
            <ion-item button [routerLink]="['/profile']" (click)="close()">{{ 'menu.profile' | translate }}</ion-item>
            <ng-template [ngxPermissionsOnly]="'admin.dashboard'">
                <ion-item button [href]="baseUrl + 'admin'">{{ 'menu.dashboard' | translate }}</ion-item>
            </ng-template>
            <ion-item button (click)="close('logout')" lines="none" detail="false">{{ 'menu.logout' | translate }}</ion-item>
            <!-- <ion-item lines="none" detail="false" button (click)="close()">Close</ion-item> -->
        </ion-list>
    `
})
export class HeaderDropdownComponent {
    public baseUrl = environment.baseUrl;

    constructor(public popoverController: PopoverController) {}
  
    close(action = '') {
        this.popoverController.dismiss(action);
    }
}